<template>
  <div id="app">
    <div id="slider-container">
      <div class="content">
        <carousel class="carousel" :perPage="1" :autoplay="true" :autoplayHoverPause="true">
          <slide class="slide">
            <img src="./assets/NZ3I1GXJC1.jpg" alt="">
          </slide>
        </carousel>
      </div>
    </div>
    <div id="container">
      <mt-header fixed title="道路救援"></mt-header>
      <mt-navbar v-model="currentTab">
        <mt-tab-item id="叫車">叫車</mt-tab-item>
        <mt-tab-item id="估價">估價</mt-tab-item>
        <mt-tab-item id="價格表">服務條款</mt-tab-item>
      </mt-navbar>
      <router-view @tabChange="tabChange" :calc="calc"></router-view>
    </div>
    
  </div>
</template>

<script>

import { Carousel, Slide } from 'vue-carousel';

export default {
  name: 'app',
  data() {
    return {
      currentTab: '叫車',
      calc: {
        display: false,
        startAddress: '',
        endAddress: '',
        price: 0,
        total: 0,
        other: 0,
      }
    }
  },
  components: {
    Carousel,
    Slide
  },
  watch: {
    currentTab(value) {
      switch(value) {
        case '叫車':
          this.$router.push('/');
          break;
        case '估價':
          this.$router.push('/calc');
          break;
        case '價格表':
          this.$router.push('/price');
          break;
        default:
          this.$router.push('/');
      }
    }
  },
  methods: {
    tabChange(value) {
      this.currentTab = value;
    }
  },
  created() {
    let route = this.$route.name;
    switch(route) {
      case 'Home':
        this.currentTab = '叫車';
        break;
      case 'Calc':
        this.currentTab = '估價';
        break;
      case 'Price':
        this.currentTab = '價格表';
        break;
      default:
        this.currentTab = '叫車';
    }
  }
}
</script>

<style>
html {
  height: 100%;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
}
.slide {
  height: 100vh;
  opacity: 0.9;
}
.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.VueCarousel-pagination {
  position: relative;
  margin-top: -56px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-top: 50px;
  box-sizing: border-box;
  height: 100%;
}
#container {
  max-width: 490px;
  position: relative;
  height: 100%;
  box-sizing: border-box;
}
#slider-container {
  position: fixed;
  width: 100%;
  height: 100%;
  padding-left: 490px;
  box-sizing: border-box;
  top: 0;
  right: 0;
  overflow: hidden;
}

#slider-container .content {
  height: 100%;
  background: rgba(0,0,0,0.3);
}

.mint-header {
  background-color: rgb(44,44,44) !important;
  border-bottom: 1px solid #d9d9d9;
  color: #fff;
  height: 50px !important;
  max-width: 490px;
}
.mint-header.is-fixed {
    z-index: 2 !important;
}

.mint-navbar .mint-tab-item.is-selected {
  border-bottom: 5px solid #26a2ff;
  color: #26a2ff;
  margin-bottom: 0 !important;
  box-sizing: border-box;
}
.mint-navbar {
  -webkit-box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
  -moz-box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
  box-shadow: 0px 0px 1px 1px rgba(0,0,0,0.3);
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

</style>


// WEBPACK FOOTER //
// src/App.vue